import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import CheckboxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const HbAdxSplitConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const adXOnlyPercentageKey = keyData + '.adXOnlyPercentage';
	const enabledKey = keyData + '.enabled';

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Hb Adx Split"
				headingPath={['Dashboard', 'Framerate', 'Network Data', 'Hb Adx Split']}
				description="Manage Hb Adx Split Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>

			<Grid container spacing={0} style={{ marginLeft: '5rem', marginTop: '3rem', width: '90%' }}>
				<Grid item xs={3}>
					<CheckboxInput
						keyData={enabledKey}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						containerStyles={{ marginTop: '4rem', width: 'fit-content' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Adx only Percentage ( % )"
						keyData={adXOnlyPercentageKey}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputProps={{ min: 0, max: 100 }}
						editable={!!rawConfig[enabledKey]}
						onChangeCheck={(inputData) => {
							if (inputData > 100) {
								alert(`Max range : 100`);
								return;
							}
							if (inputData < 0) {
								alert(`Min range : 0`);
								return;
							}
							return true;
						}}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default HbAdxSplitConfig;
